import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Button from '../../../Button';
import Profile from '../../../AuthModule/Profile';

// Router
import { getRoute } from '../../../../entry/routes';

import styles from './Auth.styl';

const cx = classNames.bind(styles);

const Auth = ({ className, isAuthenticated, profile, bonuses, signOut, isPhone, showForm }) => (
  <div className={cx('Auth', className)}>
    {isAuthenticated ? (
      <Profile {...profile} bonuses={bonuses} onSignOut={signOut} />
    ) : (
      <div className={cx('Auth__login', className)}>
        <div className={cx('Auth__text')}>
          <FormattedMessage id="auth.subline" />
        </div>
        {isPhone ? (
          <Button className={cx('Auth__button')} to={getRoute('signin')} secondary>
            <FormattedMessage id="button.login" />
          </Button>
        ) : (
          <Button className={cx('Auth__button')} onClick={showForm} secondary>
            <FormattedMessage id="button.login" />
          </Button>
        )}
      </div>
    )}
  </div>
);

Auth.defaultProps = {
  className: '',
};

Auth.propTypes = {
  className: PropTypes.string,
  isAuthenticated: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
  bonuses: PropTypes.number.isRequired,
  signOut: PropTypes.func.isRequired,
  showForm: PropTypes.func,
  isPhone: PropTypes.bool.isRequired,
};

export default Auth;
